import { Link } from 'react-router-dom';

export const NotFoundPage = (): JSX.Element => {
  return (
    <section>
      <h2 style={{ fontSize: 22 }}>404 - Page Not Found</h2>
      <p>お探しのページは見つかりませんでした。</p>
      <Link to="/" style={{ color: '#1976d2' }}>
        トップページへ戻る
      </Link>
    </section>
  );
};
